module.exports = __webpack_public_path__ + "img/20.8c6e456e.jpg";